import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../../components/Button";
import DictionaryWordImportForm from "./DictionaryWordImportForm";

class DictionaryWordImportModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      saving: false,
    };

    this.formRef = React.createRef();

    this.toggleModal = this.toggleModal.bind(this);
    this.submit = this.submit.bind(this);
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen
    })
  }

  submit(){
    this.formRef.current.save()
  }

  render() {
    const {saving, modalOpen} = this.state;

    return <React.Fragment>
      <Button onClick={this.toggleModal} className="mr-2"><i className="fas fa-download" /> Importuj do słownika</Button>

      <Modal isOpen={modalOpen} toggle={this.toggleModal}>
        <ModalHeader toggle={this.toggleModal}>Importuj do słownika</ModalHeader>
        <ModalBody>
          <DictionaryWordImportForm
            dictionaryId={this.props.dictionaryId}
            onSaved={dictionary => {
              this.toggleModal();
              this.props.onImported(dictionary);
            }}
            ref={this.formRef}
            onSavingStart={() => this.setState({ saving: true })}
            onSavingStop={() => this.setState({ saving: false })}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="mb-0" onClick={this.toggleModal}>Anuluj</Button>
          <Button
            loading={saving}
            onClick={this.submit}
          >Importuj</Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
  }
}

DictionaryWordImportModal.propTypes = {
  dictionaryId: PropTypes.number.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onImported: PropTypes.func.isRequired,
};

export default DictionaryWordImportModal;
